module.exports = __webpack_public_path__ + "img/Group 311.b3cfd1c0.png";